import React from "react";
import PropTypes from "prop-types";

import styles from "./breadcrumbs.module.scss";

function Breadcrumbs(props) {
  const breadcrumbs = props.items.map((item, i) => {
    if (!item.path) {
      return (
        <li key={i} className={styles.item}>
          <span>{item.title}</span>
        </li>
      );
    }
    return (
      <li
        key={i}
        className={styles.item}
        itemProp="itemListElement"
        itemScope
        itemType="https://schema.org/ListItem"
      >
        <a
          href={item.path}
          className={styles.link}
          itemType="https://schema.org/Thing"
          itemProp="item"
        >
          <span itemProp="name">{item.title}</span>
        </a>
        <meta itemProp="position" content={i + 1} />
      </li>
    );
  });
  return (
    <ul
      className={styles.root}
      itemScope
      itemType="https://schema.org/BreadcrumbList"
    >
      {breadcrumbs}
    </ul>
  );
}

Breadcrumbs.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      path: PropTypes.string
    })
  ).isRequired
};
export default Breadcrumbs;
